import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-flow-issue-check",
  templateUrl: "./flow-issue-check.component.html",
  styleUrls: ["./flow-issue-check.component.scss"],
})
export class FlowIssueCheckComponent implements OnInit {
  flowData: any;
  contentType: "flow" | "bundle" = "flow";

  constructor(
    public dialogRef: MatDialogRef<FlowIssueCheckComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.flowData = data.flowData;
    this.contentType = data?.contentType === "bundle" ? "bundle" : "flow";
  }

  get followingPhrase(): string {
    return this.contentType === "bundle" ? "using" : "following";
  }

  ngOnInit() {}

  onYes() {
    this.dialogRef.close({ hasIssues: true });
  }

  onNo() {
    this.dialogRef.close({ hasIssues: false });
  }

  close() {
    this.dialogRef.close({ hasIssues: null });
  }
}


